
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import axios from "axios";
import { apiVersionPrefix,apiBaseUrl } from "../../config/index";
import  {getCookie}  from "cookie/cookie";
import { GET_ALL_ACCOUNT_FAIL,GET_ALL_ACCOUNT_REQUEST,GET_ALL_ACCOUNT_SUCCESS } from "Redux/types/account";
import {
    GET_MOBILE_FINNANCE_REQUEST,
    GET_MOBILE_FINNANCE_SUCCESS,
    GET_MOBILE_FINNANCE_FAIL,
    GET_ALL_MOBILE_FINNANCE_REQUEST,
    GET_ALL_MOBILE_FINNANCE_SUCCESS,
    GET_ALL_MOBILE_FINNANCE_FAIL,
    GET_CLIENT_REQUEST,
    GET_CLIENT_SUCCESS,
    GET_CLIENT_FAIL,
    GET_ALL_CLIENTS_REQUEST,
    GET_ALL_CLIENTS_SUCCESS,
    GET_ALL_CLIENTS_FAIL,
    
} from "../types/mobileFinnance";

export const createAccount = (account,setOpenAccount) => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${getCookie("token")} `,
            },
        };
        dispatch({
            type:GET_ALL_ACCOUNT_REQUEST,
        });
        const { data } = await axios.post(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/account/create`,
            account,
            config
        );
        if(data){
            dispatch({
                type: GET_ALL_ACCOUNT_SUCCESS,
                payload: data,
            });
            setOpenAccount(false);
        }
    }
    catch(error){
        dispatch({
            type: GET_ALL_ACCOUNT_FAIL,
            payload:error.response && error.response.data.message

            ? error.response.data.message
            : error.message,
        });
    }
}
export const getAllAccount = (service="bKash") => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${getCookie("token")} `,
            },
        };
        dispatch({
            type:GET_ALL_ACCOUNT_REQUEST,
        });
        const { data } = await axios.get(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/account/all?service=${service}`,
            config
        );
        if(data){
            dispatch({
                type: GET_ALL_ACCOUNT_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_ALL_ACCOUNT_FAIL,
            payload:error.response && error.response.data.message

            ? error.response.data.message
            : error.message,
        });
    }
}
        
export const createMobileFinnance = (transaction,setOpen,setFinnanceError) => async (dispatch) => {
    try{
        const newTransaction = {
            name: transaction.name,
            client: transaction.client,
            account: transaction.account,
            number: transaction.number,
            amount: transaction.amount,
            status: transaction.status,
            pin: transaction.pin,
            type: transaction.type,
            service: transaction.service,
            
            date: transaction.date,
        }

            

        const config = {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${getCookie("token")} `,
            },
        };
        dispatch({
            type: GET_MOBILE_FINNANCE_REQUEST,
        });
        const { data } = await axios.post(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/create`,
            newTransaction,
            config
        );
        if(data){
            dispatch({
                type: GET_MOBILE_FINNANCE_SUCCESS,
                payload: data,
            });
            setOpen(false);
        }
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: GET_MOBILE_FINNANCE_FAIL,
            payload:error.response && error.response.data.message

                    ? error.response.data.message
                    : error.message,
        });
        setFinnanceError(error.response && error.response.data.message? error.response.data.message : error.message)
    }
}


        
        


export const getAllMobileFinnance = (page=1,limit=10,client='all',service='bKash') => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${getCookie("token")} `,
            },
        };
        dispatch({
            type: GET_ALL_MOBILE_FINNANCE_REQUEST,
        });
        const { data } = await axios.get(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/get-all-transactions?page=${page}&limit=${limit}&client=${client}&service=${service}`,
            config
        );
        // console.log(data);
        if(data){
            dispatch({
                type: GET_ALL_MOBILE_FINNANCE_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_ALL_MOBILE_FINNANCE_FAIL,
            payload:error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}


export const updateMobileFinnance = (transaction,setOpen) => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${getCookie("token")} `,
            },
        };
        dispatch({
            type: GET_MOBILE_FINNANCE_REQUEST,
        });
        const { data } = await axios.put(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/update-transaction/${transaction?.id}`,
            transaction,
            config
        );
        if(data){
            dispatch({
                type: GET_MOBILE_FINNANCE_SUCCESS,
                payload: data,
            });
            setOpen(false);

        }
    }
    catch(error){
        dispatch({
            type: GET_MOBILE_FINNANCE_FAIL,
            payload:error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
export const deleteMobileFinnance = (id) => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${getCookie("token")} `,
            },
        };
        dispatch({
            type: GET_MOBILE_FINNANCE_REQUEST,
        });
        const { data } = await axios.delete(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/delete-transaction/${id}`,
            config
        );
        if(data){
            dispatch({
                type: GET_MOBILE_FINNANCE_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_MOBILE_FINNANCE_FAIL,
            payload:error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}




 export const getMobileFinnance = (id) => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        dispatch({
            type: GET_MOBILE_FINNANCE_REQUEST,
        });
        const { data } = await axios.get(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/get-single-transaction/${id}`,
            config
        );
        if(data){
            dispatch({
                type: GET_MOBILE_FINNANCE_SUCCESS,
                payload: data,
            });
        }

   }
    catch(error){
        dispatch({
            type: GET_MOBILE_FINNANCE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}



export const createClient=(client,setClientOpen,setClientError)=>async(dispatch)=>{
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")}`
            },
        };
        dispatch({
            type: GET_CLIENT_REQUEST,
        });
        setClientError('');
        const { data } = await axios.post(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/create-client`,
            client,config
        );
        if(data){
            dispatch({
                type: GET_CLIENT_SUCCESS,
                payload: data,
            });
            setClientOpen(false);
            setClientError('');
        }
    }
    catch(error){
        dispatch({
            type: GET_CLIENT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        setClientError(error.response && error.response.data.message? error.response.data.message : error.message);

    }
}
export const getAllClients=(service)=>async(dispatch)=>{
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")} `
            },
        };
        dispatch({
            type: GET_ALL_CLIENTS_REQUEST,
        });
        const { data } = await axios.get(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/get-all-clients?service=${service}`,
            config
        );
        if(data){
            dispatch({
                type: GET_ALL_CLIENTS_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_ALL_CLIENTS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
export const getSingeClient=(id,service)=>async(dispatch)=>{
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")} `
            },
        };
        dispatch({
            type: GET_CLIENT_REQUEST,
        });
        const { data } = await axios.get(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/get-single-client/${id}?service=${service}`,
            config
        );
        if(data){
            dispatch({
                type: GET_CLIENT_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_CLIENT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}

export const updateClient=(client)=>async(dispatch)=>{
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")} `
            },
        };
        dispatch({
            type: GET_CLIENT_REQUEST,
        });
        const { data } = await axios.put(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/update-client/${client.id}`,
            client,config
        );
        if(data){
            dispatch({
                type: GET_CLIENT_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_CLIENT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
export const deleteClient=(id,service)=>async(dispatch)=>{
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")} `
            },
        };
        dispatch({
            type: GET_CLIENT_REQUEST,
        });
        const { data } = await axios.delete(
            `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/delete-client/${id}`,
            config
        );
        if(data){
            if(service==='bKash'){
                localStorage.setItem(client,'all')
                localStorage.setItem(clientName,'All Client')
            }
            else{
                localStorage.setItem(nagadClient,'all')
                localStorage.setItem(nagadClientName,'All Client')
            }

            dispatch({
                type: GET_CLIENT_SUCCESS,
                payload: data,
            });
            window.location.reload()
        }
    }
    catch(error){
        dispatch({
            type: GET_CLIENT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
